import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from '../Common/SelectCommonDefault';
import CheckDefecto from '../../../../Common/Components/CheckDefecto';
import Buscador from '../../Buscador';


class NuevaSolicitud extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            denominacionCuenta: "",
            descripcionCuenta:"",
            codigoPlanta:"",
            promotorId:this.props.data.promotorSeleccionado,
            promotorNombre:""
        };
        this.handleChangeDatosGenerales = this.handleChangeDatosGenerales.bind(this)
        this.seleccionarSucursal = this.seleccionarSucursal.bind(this)
    }

    handleChangeDatosGenerales(value,regex,prop) {
        let validate = regex.test(value)
        
        if (validate){ 
            this.props.onBlurTextBox(prop, value);
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.data.promotorSeleccionado!=nextProps.tarjetas.solicitudCuenta.promotorSeleccionado){
            this.props.seleccionarPromotor(nextProps.tarjetas.solicitudCuenta.promotorSeleccionado)
            let nombre = this.props.data.ATLAS_PROMOTOR.filter((p) => p.Id == nextProps.tarjetas.solicitudCuenta.promotorSeleccionado)
            if(nombre[0]){
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:nombre[0].Descripcion})  
            }else{
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:""})
            }     
        }
        if(this.props.data.promotorSeleccionado && this.state.promotorNombre == "" && this.props.data.ATLAS_PROMOTOR &&  this.props.data.ATLAS_PROMOTOR.length>0){
            let nombre = this.props.data.ATLAS_PROMOTOR.filter((p) => p.Id == this.props.data.promotorSeleccionado)
            if(nombre[0]){
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:nombre[0].Descripcion})  
            }  
        }
    }

    seleccionarSucursal(action,idSucursal){
        this.props.selectCombo(action,idSucursal);
        this.props.selectSucursal(idSucursal);
    }

    render() {
        const { data, seleccionarPromotor, selectCombo, productoSelected, selectCheckBox,loadDataFromTarjetas, tarjetas, selectSucursal } = this.props;
        const { GET_PRODUCTO_DEFAULT_VISA_PRODUCTO, ATLAS_SUCURSALES, PRODUCTO, ATLAS_TIPO_CUENTA, ERROR_CUENTA, ATLAS_GRUPO_AFINIDAD, ATLAS_DISTRIBUCION, ATLAS_COMERCIALIZADORA,ATLAS_PROMOTOR } = data;
        
        let selecciones = data;
        let modifProducto = null
        let valoresDefault = !tarjetas.esModificacion ? GET_PRODUCTO_DEFAULT_VISA_PRODUCTO : tarjetas.datosSolicitud //SI ES UNA MODIFICACION SE REEMPLAZAN LOS DEFAULT POR LOS VALORES SELECCIONADOS EN LA SOLICITUD A MODIFICAR
        let showGA = false;
        let showCD = false;
        let showCOM = false;
        let product = null;
        let subtipoArray = data.GET_SUBTIPO_CUENTA ? data.GET_SUBTIPO_CUENTA : [];
        let esNuevosAtributos =  (data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.NuevosAtributos);

        if(data.GET_PRODUCTO_VISA_PRODUCTO_ID && !esNuevosAtributos){
            subtipoArray = subtipoArray.filter(tipo=>tipo.CodigoSubtipoCuenta != "NA")
        }

        //CONDICIONES PARA MOSTRAR O NO COMBOS SEGÚN EL PRODUCTO SELECCIONADO
        if (data && data.GET_PRODUCTO_VISA_PRODUCTO_ID) {
            product = data.GET_PRODUCTO_VISA_PRODUCTO_ID
            if (product.AsociaGrupoAfinidad) showGA = true;
            if (product.UtilizaCodigoDistribucion) showCD = true;
            if (product.HabilitaComercializadora) showCOM = true;
        }

        let haySucursal = data.sucursalSeleccionadaId > 0


        //SI SE TRATA DE UNA MODIFICACIÓN, LO PRIMERO QUE SE DEBE CARGAR AUTOMÁTICAMENTE ES LA SUCURSAL, PARA QUE FILTRE LOS PRODUCTOS.
        if(tarjetas.esModificacion && !haySucursal && !tarjetas.vuelveDeAdicional){
            let suc = parseInt(tarjetas.datosSolicitud.sucursalSeleccionadaId)
            this.seleccionarSucursal("sucursalSeleccionadaId",suc)
        }

        //SI YA SE CARGÓ LA SUCURSAL PARA LA MODIFICACIÓN, LO SIGUIENTE ES CARGAR EL PRODUCTO, QUE A SU VEZ CARGARÁ TODOS LOS VALORES POSIBLES EN LOS COMBOS.
        if(tarjetas.esModificacion && haySucursal && PRODUCTO && PRODUCTO.length > 0 && (!data.GET_PRODUCTO_VISA_PRODUCTO_ID ||(data.GET_PRODUCTO_VISA_PRODUCTO_ID && !data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id)) && !tarjetas.vuelveDeAdicional){
            let prod = parseInt(tarjetas.datosSolicitud.ProductoId)
            this.props.productoSelected(prod);
        }

        //UNA VEZ QUE SE CARGÓ EL PRODUCTO SE COPIAN LAS SELECCIONES DE LA SOLICITUD ORIGINAL POR SECCIÓN Y PASA A TRUE EL FLAG DE DATOS CARGADOS.
        if(!data.isFetching && !this.props.tarjetas.vuelveDeAdicional && tarjetas.esModificacion && data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id && !data.datosGeneralesModificacion){

            //SE BUSCARÁ QUE EL CAMPO AÚN NO SE HAYA CARGADO Y EN ALGUNOS CASOS QUE CORRESPONDA SEGÚN EL PRODUCTO

            data.denominacionCuenta != tarjetas.datosSolicitud.CuentaDenominacion && this.props.onBlurTextBox("denominacionCuenta", tarjetas.datosSolicitud.CuentaDenominacion);/*this.handleChangeDatosGenerales(tarjetas.datosSolicitud.CuentaDenominacion, /^[a-záéíóúñÑA-Z0-9\s]*$/,"denominacionCuenta" )*/
            data.descripcionCuenta != tarjetas.datosSolicitud.Descripcion && this.props.onBlurTextBox("descripcionCuenta", tarjetas.datosSolicitud.Descripcion);/*this.handleChangeDatosGenerales(tarjetas.datosSolicitud.Descripcion, /^[a-záéíóúñÑA-Z0-9\s]*$/,"descripcionCuenta" )*/
            data.codigoPlanta != tarjetas.datosSolicitud.Planta && tarjetas.datosSolicitud.Planta && this.props.onBlurTextBox("codigoPlanta", tarjetas.datosSolicitud.Planta);/*this.handleChangeDatosGenerales(tarjetas.datosSolicitud.Planta, /^[a-záéíóúñÑA-Z0-9\s]*$/,"codigoPlanta" )*/
            !data.promotorSeleccionado && this.props.seleccionarPromotor(tarjetas.datosSolicitud.PromotorId);
            tarjetas.datosSolicitud.CreaCuentaDescentralizada && this.props.selectCheckBox("cuentaPropiaPorTarjeta");
            
            

            //SI YA SE CARGARON TODOS LOS DATOS DE LA SECCIÓN PASA A TRUE EL FLAG QUE LO INDICA
            if(data.denominacionCuenta != "" && data.descripcionCuenta != "" && (( tarjetas.datosSolicitud.Planta && data.codigoPlanta!= "") || !tarjetas.datosSolicitud.Planta) && ((tarjetas.datosSolicitud.PromotorId && data.promotorSeleccionado>0) || !tarjetas.datosSolicitud.PromotorId)) this.props.cargarDatosModificacion("datosGeneralesModificacion")
            
        }



        //RECUPERA LAS SELECCIONES GUARDADAS EN TARJETAS CUANDO SE AVANZÓ A LA PANTALLA ADICIONALES Y SE VOLVIÓ, YA QUE ES EL ÚNICO LUGAR DONDE PERSISTEN.
        if(tarjetas && tarjetas.vuelveDeAdicional && !data.vuelveDeAdicionalCargado){
            loadDataFromTarjetas("vuelveDeAdicionalCargado")
            if(data.denominacionCuenta == "" || !data.denominacionCuenta) this.handleChangeDatosGenerales(tarjetas.solicitudCuenta.denominacionCuenta, /^[a-záéíóúñÑA-Z0-9\s]*$/,"denominacionCuenta" )
            if(data.descripcionCuenta == "" || !data.descripcionCuenta) this.handleChangeDatosGenerales(tarjetas.solicitudCuenta.descripcionCuenta, /^[a-záéíóúñÑA-Z0-9\s]*$/,"descripcionCuenta" )
            if(data.codigoPlanta == "" || !data.codigoPlanta) this.handleChangeDatosGenerales(tarjetas.solicitudCuenta.codigoPlanta, /^[a-záéíóúñÑA-Z0-9\s]*$/,"codigoPlanta" )
            this.props.volverASolicitudNSC(false)
        }
        
        let sucursales = ATLAS_SUCURSALES;
        if(tarjetas.esModificacion && data.sucursalSeleccionadaId){
            sucursales=sucursales.filter(suc=>suc.Id == data.sucursalSeleccionadaId)
        }

        let productos = PRODUCTO;
        if(tarjetas.esModificacion && data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id){
            productos = productos.filter(producto=>producto.Id == data.productoId)
        }
        

        return (
            <div className="row">
                <div className="datos-generales-cuenta col-md-12">
                    <div className="divisor-section bottom-separator" >
                        <h2>Datos Generales de la Cuenta </h2>
                    </div>
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">Sucursal </label>
                        <SelectCommonDefault  esModificacion={tarjetas.esModificacion} selecciones={selecciones} infoData={sucursales} valorCombo={valoresDefault["sucursalSeleccionadaDefaultId"] ? valoresDefault["sucursalSeleccionadaDefaultId"] : valoresDefault["sucursalSeleccionadaId"]} selectCombo={this.seleccionarSucursal} nombreAction={"sucursalSeleccionadaId"} />
                        
                        {(!data.ERROR_CUENTA["sucursalSeleccionadaId"])
                            && <label className="error">{"Debe seleccionar una sucursal."}</label>}

                    </div>
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Producto
                                    </label>
                        <SelectCommonDefault haySucursal={haySucursal} isFetchingData={data.isFetching} esModificacion={tarjetas.esModificacion} selecciones={selecciones} producto={data.GET_PRODUCTO_VISA_PRODUCTO_ID} infoData={productos} valorCombo={modifProducto} selectCombo={productoSelected} nombreAction={"productoId"} />

                        {(!data.ERROR_CUENTA["productoId"])
                            && <label className="error">{"Debe seleccionar un producto."}</label>}

                    </div>
                    
                    {subtipoArray && subtipoArray.length>0 && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">Subtipo de Cuenta </label>
                        <SelectCommonDefault  esModificacion={tarjetas.esModificacion} selecciones={selecciones} infoData={subtipoArray} valorCombo={valoresDefault["subcuentaDefaultId"] ? valoresDefault["subcuentaDefaultId"] : valoresDefault["SubtipocuentaId"]} selectCombo={selectCombo} nombreAction={"subTipoCuentaSeleccionadaId"} />
                        
                        {(!data.ERROR_CUENTA["subTipoCuentaSeleccionadaId"])
                            && <label className="error">{"Debe seleccionar un Subtipo de Cuenta."}</label>}

                    </div>}
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Denominacion de la Cuenta
                                    </label>
                        <input className="form-control default-select" placeholder={"Ingrese una denominación..."} value={tarjetas.solicitudCuenta.denominacionCuenta} onChange={!tarjetas.esModificacion ? e=>this.handleChangeDatosGenerales(e.target.value,/^[a-záéíóúñÑA-Z0-9\s]*$/,"denominacionCuenta"):e=>null} type="text" maxLength="40">
                        </input>

                        {(!data.ERROR_CUENTA["denominacionCuenta"])
                            && <label className="error">{"Debe ingresar la denominacion de la cuenta."}</label>}

                    </div>
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Descripcion de la Cuenta para mostrar en AdintaR
                                    </label>
                        <input className="form-control default-select"  type="text" placeholder={"Ingrese una descripción para AdintaR..."} value={tarjetas.solicitudCuenta.descripcionCuenta} onChange={e=>this.handleChangeDatosGenerales(e.target.value,/^[a-záéíóúñÑA-Z0-9\s]*$/,"descripcionCuenta")} >
                        </input>

                        {(!data.ERROR_CUENTA["descripcionCuenta"])
                            && <label className="error">{"Debe ingresar la descripcion de la cuenta para mostrar en AdintaR."}</label>}

                    </div>

                    {/*tarjetas.tipoEmpresa.EmpresaIndividuos == "E" && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Crear Cuentas Independientes
                                    </label> 
                        <div style={{marginLeft:"-12px"}}>
                        <CheckDefecto nombre={"Debe crearse Cuenta propia para cada tarjeta solicitada"} check={tarjetas.solicitudCuenta.cuentaPropiaPorTarjeta} activo={true} referencia={"Cuentas"} selectCheckBox={()=>selectCheckBox("cuentaPropiaPorTarjeta")}/>
                        </div>
                    </div>*/}

                    {tarjetas.tipoEmpresa.EmpresaIndividuos == "E" && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Código de Planta
                                    </label>
                        <input className="form-control default-select" type="text" placeholder={"ingrese codigo"} value={tarjetas.solicitudCuenta.codigoPlanta} onChange={e=>this.handleChangeDatosGenerales(e.target.value,/^[a-záéíóúñÑA-Z0-9\s]*$/,"codigoPlanta")} maxLength="3" >
                        </input>

                        {(!data.ERROR_CUENTA["codigoPlanta"])
                            && <label className="error">{"Debe ingresar el código de planta."}</label>}

                    </div>}

                    {showGA &&
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Grupo de afinidad
                                    </label>
                            <SelectCommonDefault esModificacion={tarjetas.esModificacion} selecciones={selecciones} infoData={ATLAS_GRUPO_AFINIDAD} valorCombo={valoresDefault["GrupoAfinidadDefaultId"] ? valoresDefault["GrupoAfinidadDefaultId"] : valoresDefault["GrupoAfinidadId"]} selectCombo={selectCombo} nombreAction={"grupoAfinidadSeleccionadoId"} />

                            {(!data.ERROR_CUENTA["grupoAfinidadSeleccionadoId"])
                                && <label className="error">{"Debe seleccionar un grupo de afinidad."}</label>}

                        </div>}

                    {showCD &&
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Distribución
                                    </label>
                            <SelectCommonDefault esModificacion={tarjetas.esModificacion} selecciones={selecciones} infoData={ATLAS_DISTRIBUCION} valorCombo={ valoresDefault["CodigoDistribucionDefaultId"] ? valoresDefault["CodigoDistribucionDefaultId"] : valoresDefault["ModalidadDistribucionLimiteId"]} selectCombo={selectCombo} nombreAction={"codigoDistribucionSeleccionadoId"} />

                            {(!data.ERROR_CUENTA["codigoDistribucionSeleccionadoId"])
                                && <label className="error">{"Debe seleccionar una distribucion."}</label>}

                        </div>}

                    {showCOM && ATLAS_COMERCIALIZADORA.length >0 &&
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Comercializadora-canal de venta
                                    </label>
                            <SelectCommonDefault esModificacion={tarjetas.esModificacion} selecciones={selecciones} infoData={ATLAS_COMERCIALIZADORA} valorCombo={ valoresDefault["ComercializadoraCanalDefaultId"] ? valoresDefault["ComercializadoraCanalDefaultId"] : valoresDefault["ComercializadoraCanalId"]} selectCombo={selectCombo} nombreAction={"comercializadoraSeleccionadaId"} />

                            {(!data.ERROR_CUENTA["comercializadoraSeleccionadaId"])
                                && <label className="error">{"Debe seleccionar una comercializadora-canal de venta."}</label>}

                        </div>}

                    <label className="label-primary">Promotor </label>
                    {this.state.promotorId>0 ? <div>
                        <div className="promotorSeleccionadoLabel">
                            {this.state.promotorNombre}
                            <button onClick={() => { seleccionarPromotor(0) }}>x</button>
                        </div>
                    </div> :
                        <Buscador promotores={ATLAS_PROMOTOR} seleccionarPromotor={seleccionarPromotor} />
                    }
                </div>
            </div>

        )
    }
}

export default NuevaSolicitud;